import React from "react";
import FilterLabel from "../FilterLabel/FilterLabel";

import "./TagFilter.css";

export type Props<TOption> = {
    title?: string;
    extractTitle: (item: TOption) => string;
    extractValue: (item: TOption) => string;
    options: TOption[];
} & (
    | {
          onChange: (value: TOption | null) => void;
          value: TOption | null;
          multiple: false;
      }
    | {
          onChange: (value: TOption[] | null) => void;
          value: TOption[] | null;
          multiple: true;
      }
);

export default function TagFilter<TOption>(props: Props<TOption>) {
    
    return (
        <div className="TagFilter">
            {props.title ? <FilterLabel title={props.title} /> : null}

            {props.options.map(option => {
                const value = props.extractValue(option);
                const isSelected = props.multiple
                    ? props.value?.find(opt => props.extractValue(opt) === value) != null
                    : props.extractValue(props.value as TOption) === value;

                let onClick = () => {
                    if (props.multiple) {
                        if (props.value?.find(opt => props.extractValue(opt) === value) != null) {
                            props.onChange(props.value.filter(opt => props.extractValue(opt) !== value));
                        } else {
                            props.onChange([...(props.value ?? []), option]);
                        }
                    } else {
                        props.onChange(option);
                    }
                };
                
                const formattedOption = (typeof option === 'string' && props.title ==='Market') ? option.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()) : option

                return (
                    <button key={value} className={"TagFilter-tag " + (isSelected ? "is-active" : "")} onClick={onClick}>
                        {formattedOption}
                    </button>
                );
            })}
        </div>
    );
}
